<template>
  <div class="feature-info-container default-info-card"
    v-if="dataList.length > 0"
  >
    <div class="feature-info-control">
      <svg-icon iconName="el-Close"
        @click="dataListClose()"
      ></svg-icon>
    </div>
    <el-scrollbar max-height="16.875rem">
      <div class="feature-info-item"
        v-for="(item, index) of dataList"
        :key="index"
        @click="featureInfoClick(item)"
      >
        <div
          class="feature-info-item-attr"
          v-for="(key, keyIndex) of getItemKeys(item)"
          :key="keyIndex"
          @mouseover="mouseoverFn($event, item)"
          @mouseout="mouseoutFn($event, item)"
        >
          <div class="feature-info-attr-key ellipsis"
            :title="key"
          >
            {{ key }}
          </div>
          <div class="feature-info-attr-value">
            {{ item[key] }}
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script setup>
import { 
  onMounted, onUnmounted,
  computed, ref, toRaw,
} from 'vue';
import store from '@/store';
import { queryFeatureInfo } from '@/api/MapManage';

const props = defineProps({
  mapId: { type: [String, Number], required: true },
});

const homeMap = computed(() => store.getters['getHomeMap']),
  map = toRaw(homeMap.value),
  layerGroup = L.featureGroup().addTo(map);

const dataList = ref([]);
const dataListClose = () => {
  dataList.value.splice(0);
  layerGroup.clearLayers();
};

const featureInfoClick = (item) => {
  const { layer } = item;
  const bounds = layer && layer.getBounds();
  bounds && bounds.isValid() && map.fitBounds(bounds);
};

const mouseoverFn = (event, item) => {
  const layer = item['layer'];
  layer && layerGroup.addLayer(layer);
};

const mouseoutFn = (event, item) => {
  const layer = item['layer'];
  layer && layerGroup.removeLayer(layer);
};

const getItemKeys = (item) => {
  const checkArr = ['geom', 'layer'];
  return Object.keys(item).filter(key => !checkArr.includes(key));
};

const featureLayerInit = (list) => {
  layerGroup.clearLayers();
  list.forEach(item => {
    const json = JSON.parse(item['geom']);
    item['layer'] = L.geoJSON(json);
  });
};

const featureInfoRequest = (click) => {
  if (!props.mapId) return;
  queryFeatureInfo({
    mapId: props.mapId,
    lon: click.latlng.lng,
    lat: click.latlng.lat,
  }).then(res => {
    if (res.data.code == 1004) {
      dataList.value = res.data.data;
      featureLayerInit(res.data.data);
    }
  }).catch(err => {
    console.log(err);
  });
};

onMounted(() => {
  map.on('click', featureInfoRequest);
});

onUnmounted(() => {
  map.off('click', featureInfoRequest);
  layerGroup.clearLayers();
  map.removeLayer(layerGroup);
});
</script>

<style lang='less' scoped>
.feature-info-container{
  position: absolute;
  top: 10px;
  left: calc(var(--nav-panel-width) + 20px);
  width: 260px;
  transition: left 0.4s;
  .feature-info-control{
    text-align: right;
    .svg-icon{
      font-size: 14px;
      cursor: pointer;
    }
  }
  .feature-info-item{
    border-bottom: 1px solid var(--borderColor_2);
    padding: 5px;
    &:hover{
      background-color: rgba(33, 88, 233, 0.2);
      border-radius: 5px;
    }
    .feature-info-item-attr{
      display: flex;
      font-size: 16px;
      .feature-info-attr-key{
        width: 80px;
        color: var(--fontColor_18);
      }
      .feature-info-attr-value{
        flex: 1;
        min-width: 0;
        color: var(--fontColor_24);
      }
    }
  }
}
</style>
